import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { ActiveYearChanged } from '../store/actions/active-year.actions';
import { IAppState } from '../store/states/app.state';
import { AppSettingsService } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class ActiveYearService {
  private appSettingsService = inject(AppSettingsService);
  private store = inject(Store<IAppState>);
  private subject = new BehaviorSubject<number | null>(null);

  current$: Observable<number | null> = this.subject.asObservable();

  current(): number {
    const value = this.subject.value;
    if (value === null) {
      const fallback = new Date().getFullYear() - 1;
      console.warn(
        `ActiveYearService accessed before bootstrap; falling back to ${fallback}`
      );
      return fallback;
    }
    return value;
  }

  bootstrap(): Promise<number> {
    return firstValueFrom(this.appSettingsService.getActiveYear()).then((response) => {
      this.subject.next(response.activeYear);
      return response.activeYear;
    });
  }

  update(year: number): Observable<number> {
    return new Observable<number>((subscriber) => {
      this.appSettingsService.upsertActiveYear({ activeYear: year }).subscribe({
        next: (response) => {
          this.subject.next(response.activeYear);
          this.store.dispatch(new ActiveYearChanged({ year: response.activeYear }));
          subscriber.next(response.activeYear);
          subscriber.complete();
        },
        error: (error) => subscriber.error(error)
      });
    });
  }
}
